import paladin from "./../assets/portfolio/paladin.png";
import layersix from "./../assets/portfolio/layersix.png";
import foresight from "./../assets/portfolio/foresight.png";
import memory from "./../assets/portfolio/memory.png";
import peereditr from "./../assets/portfolio/peereditr.png";
import acuity from "./../assets/portfolio/acuity.png";
import iota from "./../assets/portfolio/iota.webp";
import pantheon from "./../assets/portfolio/pantheon.webp";
import petra from "./../assets/portfolio/petra.png";
import iris from "./../assets/portfolio/iris.png";
import homeslice from "./../assets/portfolio/homeslice.png";
import channeltime from "./../assets/portfolio/channeltime.png";
import robhat from "./../assets/portfolio/robhat.png";
import gainful from "./../assets/portfolio/gainful.png";
import coverstar from "./../assets/portfolio/coverstar.jpg";
import onederful from "./../assets/portfolio/onederful.png";
import dataagora from "./../assets/portfolio/dataagora.png";
import rooster from "./../assets/portfolio/rooster.png";
import wildfire from "./../assets/portfolio/wildfire.jpg";
import blitz from "./../assets/portfolio/blitz.png";
import glints from "./../assets/portfolio/glints.png";
import atlas from "./../assets/portfolio/atlas.jpeg";
import pitvidura from "./../assets/portfolio/pitvidura.png";
import coba from "./../assets/portfolio/coba.png";
import orbit from "./../assets/portfolio/orbit.png";
import skindex from "./../assets/portfolio/skindex.png";
import workngo from "./../assets/portfolio/workngo.png";
import simplata from "./../assets/portfolio/simplata.png";
import certifiedrecs from "./../assets/portfolio/certifiedrecs.png";
import fourthstate from "./../assets/portfolio/fourthstate.png";
import distributed from "./../assets/portfolio/distributed.png";
import opthrift from "./../assets/portfolio/opthrift.png";
import photon from "./../assets/portfolio/photon.png";
import tileworks from "./../assets/portfolio/tileworks.png";
import diced from "./../assets/portfolio/diced.png";
import biosense from "./../assets/portfolio/biosense.png";
import turing from "./../assets/portfolio/turing.png";
import flipout from "./../assets/portfolio/flipout.png";
import beyondvision from "./../assets/portfolio/beyondvision.png";
import blackbook from "./../assets/portfolio/batches/spring_21/blackbook.png";
import loggicat from "./../assets/portfolio/batches/spring_21/loggicat.png";
import shopt from "./../assets/portfolio/batches/spring_21/shopt.png";
import sportvue from "./../assets/portfolio/batches/spring_21/sportvue.png";
import chargenest from "./../assets/portfolio/batches/fall_2023/chargenest.jpg";
import fluyo from "./../assets/portfolio/batches/fall_2023/fluyo.png";
import materri from "./../assets/portfolio/batches/fall_2023/materri.jpeg";
import watneyrobotics from "./../assets/portfolio/batches/fall_2023/watneyrobotics.jpg";
import caravan from "./../assets/portfolio/batches/fall_24/caravan.png";
import gekodb from "./../assets/portfolio/batches/fall_24/gekodb.png";
import morphic from "./../assets/portfolio/batches/fall_24/morphic.png";
import sparkd from "./../assets/portfolio/batches/fall_24/sparkd.png";
import dura from "./../assets/portfolio/batches/spring_24/dura.png";
import hollia from "./../assets/portfolio/batches/spring_24/hollia.png";
import nomadic from "./../assets/portfolio/batches/spring_24/nomadic.png";
import trace from "./../assets/portfolio/batches/spring_24/trace.png";
import claratear from "./../assets/portfolio/batches/spring_25/claratear.png";
import fashionweek from "./../assets/portfolio/batches/spring_25/fashionweek.png";
import posana from "./../assets/portfolio/batches/spring_25/posana.avif";
import stagingsphere from "./../assets/portfolio/batches/spring_25/stagingsphere.png";
import studykit from "./../assets/portfolio/batches/spring_25/studykit.svg";
import entropica from "./../assets/portfolio/batches/fall_25/entropica.png";
import hexara from "./../assets/portfolio/batches/fall_25/hexara.png";
import glauconovalabs from "./../assets/portfolio/batches/fall_25/glauconovalabs.png";
import solace from "./../assets/portfolio/batches/fall_25/solace.jpg";
import centralcoms from "./../assets/portfolio/batches/spring_26/centralcoms.png";
import deployedai from "./../assets/portfolio/batches/spring_26/deployedai.png";
import regal from "./../assets/portfolio/batches/spring_26/regal.png";
import humanbased2 from "./../assets/portfolio/batches/spring_26/humanbased2.png";

// photos
import demilune1 from "./../assets/portfolio/demilune1.jpeg";
import etch1 from "./../assets/portfolio/etch1.jpeg";
import smartbod1 from "./../assets/portfolio/smartbod1.jpeg";
import bru1 from "./../assets/portfolio/bru1.jpeg";
import einstein1 from "./../assets/portfolio/einstein1.jpeg";
import iris1 from "./../assets/portfolio/iris1.jpeg";
import nimble1 from "./../assets/portfolio/nimble.png";
import obsidian from "./../assets/portfolio/obsidian.png";
import unboard from "./../assets/portfolio/unboard.png";
import crowdcontrol1 from "./../assets/portfolio/crowdcontrol.png";
import glints1 from "./../assets/portfolio/glints1.png";
import tablink1 from "./../assets/portfolio/tablink1.png";
import c1 from "./../assets/portfolio/c1.jpeg";
import outcomes1 from "./../assets/portfolio/outcomes1.jpeg";
import blitz1 from "./../assets/portfolio/blitz1.jpeg";
import rooster1 from "./../assets/portfolio/rooster1.jpeg";
import wist1 from "./../assets/portfolio/wist1.jpeg";
import zypper1 from "./../assets/portfolio/zypper1.jpeg";
import healthpoint from "./../assets/portfolio/healthpoint.png";
import polyture from "./../assets/portfolio/polyture.png";
import musa from "./../assets/portfolio/musa.jpg";
import myntor from "./../assets/portfolio/myntor.png";
import dewaste from "./../assets/portfolio/dewastelogo.png";
import kovadx from "./../assets/portfolio/kovadxlogo.png";
import placeware from "./../assets/portfolio/placewarelogo.png";

// press
import tc from "./../assets/press/tc.png";
import huffpost from "./../assets/press/huffpost.png";
import forbes from "./../assets/press/forbes.png";
import mic from "./../assets/press/mic.png";
import recode from "./../assets/press/recode.png";
import wired from "./../assets/press/wired.png";
import bb from "./../assets/press/bb.jpg";
import dailycal from "./../assets/press/dailycal.jpg";
import e27 from "./../assets/press/e27.png";
import alchemy from "./../assets/press/alchemy.jpeg";

// https://medium.com/@blitzesports/the-blitz-team-joins-discord-e3b17578966b
// blitz

// COBA
//
//

const acquisitionTag = {
  content: "Acquired",
  backgroundColor: "#424242",
};

const ycS2026Tag = {
  content: "YC S2026",
  backgroundColor: "#EC8641",
};

const ycX2026Tag = {
  content: "YC X2026",
  backgroundColor: "#EC8641",
};

const ycW2020Tag = {
  content: "YC W2020",
  backgroundColor: "#EC8641",
};

const ycW2018Tag = {
  content: "YC W2018",
  backgroundColor: "#EC8641",
};

const ycS2018Tag = {
  content: "YC S2018",
  backgroundColor: "#EC8641",
};

const ycS2017Tag = {
  content: "YC S2017",
  backgroundColor: "#EC8641",
};

const ycS2015Tag = {
  content: "YC S2015",
  backgroundColor: "#EC8641",
}

const kickstarterTag = {
  content: "Kickstarter",
  backgroundColor: "#04ce78",
};

const portfolioContent = {
  tags: {
    acquisitions: [acquisitionTag],
    yc: [ycS2026Tag, ycX2026Tag, ycW2020Tag, ycW2018Tag, ycS2018Tag, ycS2017Tag, ycS2015Tag],
    kickstarter: [kickstarterTag],
  },
  batchList: [
    {
      batchName: "S2026",
      batchNumber: 26,
      companies: [
        {
          name: "CentralComs",
          description: "We help property management companies fill vacancies faster while spending less on leasing operations by automating the process from lead to signed tenant.",
          track: "accelerator",
          logo: centralcoms,
          tags: [ycX2026Tag],
          links: [
            {
              address: "https://centralcoms.com/waitlist",
              title: "Website",
            },
          ]
        },
        {
          name: "Humanbased",
          description: "Humanbased is building the world's first portable navigation device for the visually impaired. Using CV and LiDAR, we provide hands-free, haptic guidance for precise indoor wayfinding and environmental awareness. We’re replacing canes with vision-parity physical AI.",
          track: "accelerator",
          logo: humanbased2,
          links: [
            {
              address: "https://humanbased.notion.site/acimo",
              title: "Website",
            },
          ],
        },
        { 
        name: "prbe.ai", //renamed from deployed.ai
        description: "A forward deployed AI agent for debugging in a customer's specific environment.",
        track: "accelerator",
        logo: deployedai,
        tags: [ycX2026Tag]
        },
        {
          name: "Regal",
          description: "Regal is building the operating system for legal record creation. Starting with depositions, we replace manual stenography with AI-native infrastructure that captures, structures, and indexes proceedings in real time.",
          track: "accelerator",
          logo: regal,
        }
      ],
    },
    {
      batchName: "F2025",
      batchNumber: 25,
      companies: [
        {
          name: "Entropica",
          description:
            "Carbon capture is too expensive. Our ML platform, trained from various company datasets, optimizes heat, the biggest cost bottleneck in carbon capture, in pre-existing pipelines while accepting different sizes of data. Expect measurable % gains, which save millions.",
          track: "accelerator",
          logo: entropica,
          tags: [ycS2026Tag],
          links: [
            {
              address: "https://drive.google.com/file/d/1Bp8TqanQYrxQoW31AZ34eUwr_yBJ32gT/view?usp=sharing",
              title: "Website",
            },
          ],
        },
        {
          name: "Hexara",
          description: "Simulations choke on broken meshes. Its development is painful, manual, slow. We’re automating geometry-driven processes, transforming raw thoughts and designs into simulation-ready structures instantly. From CFD to FEA to Blender, we kill the bottleneck and let ideas flow faster",
          track: "accelerator",
          logo: hexara,
          links: [
            {
              address: "https://drive.google.com/file/d/17JCkevujtZgcW0ZLEFkpnqYjwmtwGzUU/view?usp=sharing",
              title: "Website",
            },
          ],
        },
        {
          name: "Glauconova Labs",
          description: "We are reinventing glaucoma care with ultrasound-infused eyeglasses that monitor eye pressure (IOP) continuously at 92% accuracy, 80% cheaper than the market. Enabling remote physician oversight and timely therapy, we aim to avert the leading cause of irreversible blindness.",
          track: "accelerator",
          logo: glauconovalabs,
          links: [
            {
              address: "https://drive.google.com/file/d/17JCkevujtZgcW0ZLEFkpnqYjwmtwGzUU/view?usp=sharing",
              title: "Website",
            },
          ],
        },
        {
          name: "Solace",
          description: "Solace is an emotionally intelligent AI companion designed to be there when you need someone to listen, when advice feels generic, and when friends just hit you with ‘damn that sucks.’",
          track: "accelerator",
          logo: solace,
          links: [
            {
              address: "https://solacelaunch.com/",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "S2025",
      batchNumber: 24,
      companies: [
        {
          name: "ClaraTear",
          description:
            "ClaraTear is revolutionizing disease diagnostics using tear biomarkers and AI to deliver rapid, 15-minute non-invasive cardiovascular tests. Faster results, early detection, and better patient care: all made possible by a portable and scalable device. Next-gen healthcare is here.",
          track: "accelerator",
          logo: claratear,
          links: [
            {
              address: "https://drive.google.com/file/d/1b4HFCCYw0AXS6PozRO9E074rtgTUvAZD/view?usp=sharing",
              title: "Website",
            },
          ],
        },
        {
          name: "Fashion Week",
          description: "Fashion Week is the go-to platform for emerging designer brands, streamlining consumer discovery and boosting conversion rates. We bypass social media's unpredictable algorithms to drive higher brand acquisition and sales.",
          track: "accelerator",
          logo: fashionweek,
          links: [
            {
              address: "https://www.artemismarketplace.net/",
              title: "Website",
            },
          ],
        },
        {
          name: "Posana",
          description: "Our goal is simple: to provide clean, flavorful protein for America.",
          track: "accelerator",
          logo: posana,
          links: [
            {
              address: "https://eatposana.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Staging Sphere",
          description: "AI Powered Real Estate Staging. Instantly generate high-quality staged photos—ready in minutes, not days at a 5x lower price. Our competitive advantage? Web scraping—AI scrapes unstaged listings, identifying untapped potential! Staging that sells. Leads that convert.",
          track: "accelerator",
          logo: stagingsphere,
          links: [
            {
              address: "Stagingsphere.com",
              title: "Website",
            },
          ],
        },
        {
          name: "StudyKit",
          description: "StudyKit is an AI-powered studying app that makes it easy for students to stay on track with their education. We transform user-uploaded content from notes, textbooks, and lectures into daily, bite-sized lessons that make studying approachable.",
          track: "accelerator",
          logo: studykit,
          links: [
            {
              address: "https://studykit.app/",
              title: "Website",
            },
          ],
        }
      ],
    },
    {
      batchName: "F2024",
      batchNumber: 23,
      companies: [
        {
          name: "Caravan",
          description:
            "A GPU-bound network of compute sourced from general consumers and university research labs to make executing ML workloads cheaper, faster, and more secure through dynamic allocation of GPUs at runtime.",
          track: "accelerator",
          logo: caravan,
          links: [
            {
              address: "https://thecaravan.cloud",
              title: "Website",
            },
          ],
        },
        {
          name: "GekoDB",
          description:
            "An open-source graph database management platform that leverages novel node2vec models for vector search, converting unstructured and structured data into knowledge graphs for AI applications.",
          track: "accelerator",
          logo: gekodb,
        },
        {
          name: "Morphic",
          description:
            "An AI assistant that generates SwiftUI code.",
          track: "accelerator",
          logo: morphic,
          links: [
            {
              address: "https://www.morphic-app.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Sparkd, Inc.",
          description:
            "Developing public infrastructure to integrate EV charging in parking meters.",
          track: "accelerator",
          logo: sparkd,
        },
      ],
    },
    {
      batchName: "S2024",
      batchNumber: 22,
      companies: [
        {
          name: "Dura",
          description:
            "A mobile app that collects concussion data, provides patient resources, and uses machine learning for personalized recovery recommendations.",
          track: "accelerator",
          logo: dura,
        },
        {
          name: "Hollia",
          description:
            "An all-in-one analytics solution that helps companies understand their physical customers through a network of connected boxes, AI, and an intuitive dashboard.",
          track: "accelerator",
          logo: hollia,
          links: [
            {
              address: "https://hollia.fr/",
              title: "Website",
            },
          ],
        },
        {
          name: "Nomadic Drones",
          description:
            "A Risk Management as a Service that uses autonomous drones and ML for remote inspections, identifying vulnerabilities with actionable insights to improve safety and efficiency. ",
          track: "accelerator",
          logo: nomadic,
          links: [
            {
              address: "https://www.nomadicdrone.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Trace AI",
          description:
            "A generative AI platform that helps companies find and fill government contracts.",
          track: "accelerator",
          logo: trace,
        },
      ],
    },
    {
      batchName: "F2023",
      batchNumber: 21,
      companies: [
        {
          name: "ChargeNest",
          description: "ChargeNest is an EV charge management software that offer nighttime reservations for underutilized public EV chargers for people without home charging solutions, such as those in multifamily buildings",
          track: "accelerator",
          logo: chargenest,
          links: [
            {
              address: "https://chargenest.co", 
              title: "Website"
            }
          ]
        },
        {
          name: "FLUYO",
          description: "FLUYO empowers women's intimate health with an innovative self-monitoring tool, providing real-time insights to help detect anomalies in vaginal discharge and gain peace of mind",
          track: "accelerator",
          logo: fluyo,  
          links: [
            {
              address: "https://fluyo.tilda.ws/",
              title: "Website"
            }
          ]
        },
        {
          name: "Matteri",
          description: "Materri is a materials intelligence platform that streamlines the sourcing process for footwear development teams with advanced material recommendations based on design preferences",
          track: "accelerator",
          logo: materri,
          links: [
            {
              address: "https://www.materri.com/",
              title: "Website"
            }
          ]
        },
        {
          name: "Watney Robotics",
          description: "Watney Robotics builds end-to-end automated vertical farms and proprietary robotic systems using deep learning models that enable cultivation of high complexity, high margin crops where traditional automation techniques fail",
          track: "accelerator",
          logo: watneyrobotics,
          links: [
            {
              address: "https://watneyrobotics.com/",
              title: "Website"
            }
          ]
        },  
      ]
    },
    {
      batchName: "S2023",
      batchNumber: 20,
      companies: [
        {
          name: "Rocetta",
          description:
            "A user experience-focused platform that accelerates cloud development and provides an intuitive dashboard for developers of all skill levels.",
          track: "accelerator",
          links: [
            {
              address: "https://rocetta.com",
              title: "Website",
            },
          ],
        },
        {
          name: "Decoditive",
          description:
            "A next-generation Al-based marketing platform that predicts in 20 seconds the data you get in 4 weeks with Google Analytics.",
          track: "accelerator",
          links: [ 
            {
              address: "https://www.decoditive.com",
              title: "Website",
            },
          ],
        },
        {
          name: "Mindly",
          description:
            "A visual database platform that connects millions of healthcare providers with patients to accurately monitor neurological conditions.",
          track: "accelerator",
          links: [
            {
              address: "https://mindly-dev.web.app/login",
              title: "Website",
            },
          ],
        },
        {
          name: "Cartesan",
          description:
            "An app that enables restaurants to create 3D models of food from pictures and lets you use 3D menus from your phone.",
          track: "accelerator",
          links: [
            {
              address: "https://www.cartesan.app",
              title: "Website",
            },
          ],
        },
        {
          name: "EduBeyond",
          description:
            "Novel Al-based learning software that eliminates educational disparities by aiding underprivileged communities worldwide.",
          track: "accelerator",
          links: [
            {
              address: "https://www.edubeyond.org",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "F2022",
      batchNumber: 19,
      companies: [
        {
          name: "Merge",
          description:
            "Merge is a FinTech company that makes accepting payments simple, free, and in real-time. We let small businesses accept alternate payment methods (Zelle, Venmo, Cashapp, Cryptocurrencies, international wallets like Alipay, WeChat pay, UPI, Ebanx, etc.) for in-person and other eCommerce transactions for a subscription fee.",
          track: "accelerator",
          links: [
            {
              address: "https://www.joinmerge.io",
              title: "Website",
            },
          ],
        },
        {
          name: "Melody",
          description:
            "Melody is a consumer product company that offers a nicotine-free diffusor device as a transitional tool for an eventual complete cessation of vaping and smoking.",
          track: "accelerator",
          links: [
            {
              address: "https://trymelody.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Markit AI",
          description:
            "At Markit AI, we are leveraging AI and physiological data to help small to medium size businesses (SMBs) predict their customers' attention, memory, and emotions toward marketing campaigns.",
          track: "accelerator",
          links: [
            {
              address: "https://www.markit.ai/",
              title: "Website",
            },
          ],
        },
        {
          name: "Januso",
          description:
            "Januso is an AI-powered content multiplier that transforms one piece of digital content into many ready-to-publish media posts for various social media platforms with a single click.",
          track: "accelerator",
          links: [
            {
              address: "https://www.januso.vercel.app/",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "S2022",
      batchNumber: 18,
      companies: [
        {
          name: "Plots",
          description:
            "We’re building a social media platform to make it easier for people to host and attend nightlife events like clubs, parties, or festivals. Through our platform, friends can connect and bond over what parties they’ve attended, rate top party hosters, and connect with others who’ve attended the same events.",
          track: "accelerator",
          links: [
            {
              address: "https://www.plots.events/",
              title: "Website",
            },
          ],
        },
        {
          name: "IFLUR",
          description:
            "Iflur is a flooring technology that generates clean energy from people's footsteps using electromagnetic generators and 3D printing technology.",
          track: "accelerator",
          links: [
            {
              address: "https://iflur.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Outwork",
          description:
            "Outwork is an analytics platform for small and medium-sized manufacturers (SMMs). After decades of build-up, SMMs are facing unprecedented challenges; The perfect storm of heavy competition, and a dire labor shortage.",
          track: "accelerator",
          links: [
            {
              address: "https://www.outworkautomation.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Kaltu",
          description: "Buy Now Pay Later for B2B last mile delivery.",
          track: "accelerator",
          links: [
            {
              address: "https://www.getkaltu.com/",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "F2021",
      batchNumber: 17,
      companies: [
        {
          name: "NovaXS Biotech",
          description:
            "NovaXS Biotech is on a mission to provide caring future therapeutics. Led by a professional team in healthcare with a proven track record of over $40 million in fundraising experience and 5 successful business exits, NovaXS is a smart medical device startup focused on advanced drug delivery and users’ long-term health.",
          track: "accelerator",
          links: [
            {
              address: "https://www.novaxs.co/",
              title: "Website",
            },
          ],
        },
        {
          name: "Rimble",
          description:
            "Sophisticated machine learning models and proprietary raw data to create infrastructure for delightful esports experiences.",
          track: "accelerator",
          links: [
            {
              address: "https://rimble.io/",
              title: "Website",
            },
          ],
        },
        {
          name: "Gustant",
          description:
            "We want to be the actors of our terroir by modernizing the means to consume locally and to buy directly from the producer. Our vision is to become the new incontournable way to consume sustainably",
          track: "accelerator",
          links: [
            {
              address: "www.gustant.fr",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "S2021",
      batchNumber: 16,
      companies: [
        {
          name: "The Sipher Company",
          description:
            "A customer behavior platform that allows businesses to optimize their sales, marketing, and management strategies by tying customer interactions to product satisfaction. By using a series of algorithms and cutting-edge data processing techniques, we allow enterprises to frequently check-in on their customer's interactions allowing them to personalize business-customer relationships as well as reduce turnover.",
          track: "accelerator",
          links: [
            {
              address: "https://www.thesiphercompany.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "BlossomVR",
          description:
            "BlossomVR is a biofeedback virtual reality (VR) application that gamifies personalized relaxation practices to help reduce anxiety and stress - the epidemic of the 21st century. Using virtual reality and biofeedback, we provide an immersive experience that is personalized for each user. Our habit-forming storyline also helps users commit to the mindfulness practices that work best for them.",
          track: "accelerator",
          links: [
            {
              address: "https://blossomvr.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Loggicat",
          description:
            "Loggicat provides a comprehensive solution to the data spill problem, which is storing sensitive data in logs, code repositories, generated files and any other locations. Loggicat is the first company to create a seamless, uncompromising data security solution that is devops-first.",
          track: "accelerator",
          logo: loggicat,
          links: [
            {
              address: "https://www.loggicat.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Sportvue",
          description:
            "Ice hockey players look down subconsciously during practices and games, causing them to get into collisions and miss split-second opportunities to pass and shoot the puck. SportVue has built a unique training aid that helps players develop a habit of playing heads up by giving an audio and/or visual cue when a player looks down.",
          track: "accelerator",
          logo: sportvue,
          links: [
            {
              address: "https://sportvue.co/",
              title: "Website",
            },
          ],
        },
        {
          name: "Shopt",
          description:
            "A local resale marketplace that relies on smart lockers to handle the transactions, eliminating the inconveniences and unreliability of current resale options.",
          track: "incubator",
          logo: shopt,
          links: [
            {
              address: "https://www.shoptnow.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Blackbook",
          description:
            "An education development platform designed to empower Black students with tools that enable peer-to-peer connection, academic enrichment, and professional success.",
          track: "incubator",
          logo: blackbook,
          links: [
            {
              address: "https://www.blackbooku.com/",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "F2020",
      batchNumber: 15,
      companies: [
        {
          name: "KovaDx",
          description:
            "KovaDx uses 3D Quantitative Phase imaging to obtain data about cells, which is used in their proprietary deep learning models to build diagnostic tools for sickle cell disease, malaria and blood cancers. They seek to reach underserved communities and address inequities in health care for patients by providing fast, affordable, and accurate diagnosis and monitoring.",
          logo: kovadx,
          links: [
            {
              address: "https://www.kovadx.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "DeWaste",
          description:
            "DeWaste provides analytics for food waste. Their product, DeWaste Excess, collects real-time data of food leftovers using computer vision. This data is then used to generate actionable insights which can be used by restaurant managers to reduce food waste by engineering the menu to adapt to customer preferences. Their other product is called DeWaste Kitchen, which reduces errors in food preparation to cut costs in the kitchen.",
          logo: dewaste,
          links: [
            {
              address: "https://de-waste.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Placeware",
          description:
            "Placeware equips brick and mortar businesses with automated monitoring of human interaction at their locations, which allows them to better achieve their business goals. Their technology can provide traffic analysis, an understanding of how visitors interact with the physical space, action insights on customer behavior, and trend analysis using heatmaps over weeks and months.",
          logo: placeware,
          links: [
            {
              address: "https://placeware.io/auth/register",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "S2020",
      batchNumber: 14,
      companies: [
        {
          name: "Healthpoint",
          description:
            "We make it easy for therapists to manage their billing and online presence. Healthpoint is a web app that helps therapists process and manage payments, automate the insurance claims process, and set up their practice online. Instead of hiring an office assistant, we automate common back office tasks so therapists can focus on working with patients. Features include an online teletherapy-focused directory, credit card management, recurring payments, appointment management, and superbill automation.",
          logo: healthpoint,
          links: [
            {
              address: "https://usehealthpoint.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Musa",
          description:
            "Musa is a digital platform that connects artists with unconventional venues to create community engagements such as art shows, musical performances, exhibitions, and consignment options. We act as a back-office handling the pain points for artists and hosts to enable them to focus on their work while Musa takes care of payments, insurance, advertising, pricing help, and art-hanging solutions. We bring out audience members and art-chasers who want to engage in their local art scene through our social media platforms, newsletter, and eventually our location-based calendar of art and events.",
          logo: musa,
          links: [
            {
              address: "https://www.musaexhibition.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Myntor",
          description:
            "Myntor produces online courses that help students exceed conventional performance metrics through a unique problem-based learning experience. Lectures today are not contextualized to what students find relevant and heavily pedantic, which makes understanding and retaining content extremely difficult. Currently, to improve academic performance, students must either use a combination of digital tools (Khan Academy, etc.) or simply find a better teacher. While this may work for some students, online classes are often even more pedantic than in-person lectures, and finding a better teacher is subject to geographic constraints. No current solution exists that is as effective as taking a class in-person, but is as accessible as an online course.",
          logo: myntor,
          links: [
            {
              address: "http://myntor.io/",
              title: "Website",
            },
          ],
        },
        {
          name: "Oki",
          description:
            "Oki Office is a soundproof productivity booth designed for open-plan workspaces. These offices are not designed for productivity. They’re noisy. They’re not private. They’re distracting. We are designing an office booth where employees can focus. Walk in, plug in your laptop, and immediately get access to a large monitor and a spacious desk.",
        },
        {
          name: "Polyture",
          description:
            "Polyture is a data exploration and analytics platform that enables the flexibility of custom code solutions while providing hugely increased speed and clarity throughout analysis.",
          logo: polyture,
          links: [
            {
              address: "https://www.polyture.com/",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "F2019",
      batchNumber: 13,
      companies: [
        {
          name: "Biosense",
          description:
            "Our mission is to develop solutions that enable all animal-associated science to be highly quantative. Our wireless, non-invasive telemetry solution delivers data regarding high frequency locomotor behavior, while meeting the rigorous standards of animal research. We offer a post-processing solution that has been validated to automatically report rodent activity, and are working with our research partners on a number of other metrics, including pain, addiction, and mortality. Biosense has been funded by the NIH and 8VC, and our devices have been used by researchers at Stanford, Rockefeller, UC Santa Barbara, Indiana University, and the University of Michigan.",
          logo: biosense,
          links: [
            {
              address: "https://www.biosense.ai/",
              title: "Website",
            },
          ],
        },
        {
          name: "Turing Certs",
          description:
            "A smart citizen identifier network focused on educational innovation. They are an all-in-one-place repository for certificates that guarantees integrity and expedites verifications for job seekers, enterprises, and universities. TuringCerts is an all-in-one-place repository for certificates that guarantees the integrity of records and makes verification much more efficient than conventional hiring processes. It associates individuals with W3C decentralized identifier and GDPR-compliant data privacy principle.",
          logo: turing,
          links: [
            {
              address: "https://certs.turingchain.tech/",
              title: "Website",
            },
          ],
        },
        {
          name: "Flipout",
          description:
            "Flipout is a mobile platform that allows users to make sports predictions against friends on games (NBA, NFL, MLB, NCAA, and more), follow live sports scores, and win real rewards for free, without the traditional risk of sports betting. Users don’t have to pay anything to join the platform or to place predictions. Correctly predict and win virtual Flipout coins; incorrectly predict and lose nothing. Make predictions on both win/loss and margin of victory outcomes (choose Patriots win or Patriots win by 7 points or more). Users can then spend coins earned on our platform to unlock rewards from our partner companies: everything from restaurant discounts to player jerseys.",
          logo: flipout,
          links: [
            {
              address: "https://www.flipout.io/",
              title: "Website",
            },
          ],
        },
        {
          name: "Beyond Vision",
          links: [
            {
              address: "https://beyondvision.ai/home",
              title: "Website",
            },
          ],
          logo: beyondvision,
          description:
            "A B2B SaaS platform that enhances object detection capabilities of existing computer vision systems using AI based post processing for InfraRed, thermal and grayscale cameras",
        },
      ],
    },
    {
      batchName: "S2019",
      batchNumber: 12,
      companies: [
        {
          name: "Orbit",
          description:
            "Orbit is a platform that enables organizations to streamline internal operations through spreadsheet-powered mobile apps. In minutes, anybody can create and deliver custom mobile-first experiences for their organization — all from a spreadsheet. From the sheet, administrators can easily add, edit, and release updates in real-time, allowing the platform to keep up with their organization’s day-to-day operations.",
          logo: orbit,
          links: [
            {
              address: "https://getorbit.app/",
              title: "Website",
            },
          ],
        },
        {
          name: "Skindex",
          description:
            "Skindex is an AI-powered search and discovery platform that enables users to find skincare and cosmetic products that are compatible with their skin. By leveraging existing cosmetic research on comodogenity, demographic data and machine learning, Skindex can analyze patterns from different users’ skin types and learn what ingredients might be causing a bad reaction, providing the user with instant feedback and automated product recommendations, ultimately resulting in a new way to discover skincare and cosmetic products.",
          logo: skindex,
          links: [
            {
              address: "https://www.skindex.ai",
              title: "Website",
            },
          ],
        },
        {
          name: "WorknGo",
          description:
            "A platform which allows students to work “SmartJobs”: quick, on-demand, and temporary work at local businesses, with no long-term commitments. SmartJobs also allow local businesses to fill spots at a moment’s notice, either during peak hours or when employees call in sick. We have already partnered with multiple McDonald’s franchises in Berkeley, Kiwi Campus, and many other stores to provide SmartJobs for students!",
          logo: workngo,
          links: [
            {
              address:
                "https://www.dailycal.org/2019/04/24/berkeley-startup-workngo-to-provide-access-to-temporary-student-jobs/",
              title: "Article",
            },
          ],
        },
        {
          name: "Simplata",
          links: [
            {
              address: "https://www.simplata.io",
              title: "Website",
            },
          ],
          tags: [ycW2020Tag],
          logo: simplata,
          description:
            "Simplata is developing a new way to share and connect data. We offer an end-to-end data storage, management and visualization solution. Clients can upload whatever datasets they choose and visualize them with ease. Our graph visualization software turns data into visual, interactive graphs — revealing the hidden connections at the heart of any analysis.",
        },
        {
          name: "CertifiedRecs",
          description:
            "A web platform that allows users to store, share, and view verified private references enabling authenticity in the recruiting process. Users can then send out any number of references via a simple share link. All parties involved with the reference (user, giver, viewer) must verify their own accounts, and all verified information is transparent to the other users involved with the reference.",
          logo: certifiedrecs,
          links: [
            {
              address: "https://certifiedrecs.com/",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "F2018",
      batchNumber: 12,
      companies: [
        {
          name: "Atlas Mental Health",
          description:
            "Building a K-12 mental health support network to supercharge communities with the knowledge and tools they need to keep each other mentally healthy. Their mobile applications connect parents, students, and schools to prevent student suicides and barriers to getting help for those that need it.",
          logo: atlas,
          links: [
            {
              address: "https://www.atlasmh.com/",
              title: "Website",
            },
          ],
        },
        {
          name: "Fourthstate Labs",
          description:
            "Blockchain scalability company working on Plasma, a layer 2 solution to reduce transaction fees and increase throughput of blockchains. Plasma allows users to step off the main chain(i.e. Ethereum) onto cheaper and faster side chains where transactions can be conducted.",
          logo: fourthstate,
          links: [
            {
              address: "https://github.com/fourthstate",
              title: "Github",
            },
          ],
        },
        {
          name: "COBA",
          links: [
            {
              address:
                "https://medium.com/@FreeVentures/introducing-coba-the-coffee-bar-4a02a4be5472",
              title: "FreeV Spotlight",
            },
            {
              address: "https://www.coba.coffee/",
              title: "Website",
            },
            {
              address:
                "https://www.kickstarter.com/projects/237610002/coba-coffee-you-eat-0",
              title: "Kickstarter",
            },
          ],
          tags: [kickstarterTag],
          logo: coba,
          description:
            "A solid coffee alternative made from whole coffee beans that empowers busy people to do more. While traditional coffee utilizes only 20% of the coffee bean, their bar utilizes the whole bean and contains the caffeine content of 1 cup of coffee.",
        },
        {
          name: "Escape Technologies",
          description:
            "Escape is is creating an enhanced augmented reality experience through proprietary optical architecture that will enable a compact, lightweight headset with high shareability and field of view.",
        },
        {
          name: "Pit Vedura",
          description:
            "Pit Vidura offers safe and affordable sanitation services for low-income households in dense urban slums. By developing innovative hardware and software tools, they aim to make emptying pit latrines hygienic, efficient, and affordable. Pit Vidura is backed by Unilever and the Gates Foundation to bring sustainable solutions to sanitation problems in developing countries.",
          logo: pitvidura,
          links: [
            {
              address: "https://www.pitvidura.com/",
              title: "Website",
            },
          ],
        },
      ],
    },
    {
      batchName: "S2018",
      batchNumber: 12,
      companies: [
        {
          name: "Gainful",
          logo: gainful,
          links: [
            {
              address:
                "https://thestartu.com/everyone-is-unique-why-shouldnt-your-protein-powder-be-too/",
              title: "StartU Article",
            },
          ],
          tags: [ycW2018Tag],
          description:
            "Personalized protein powder, delivered monthly. Recently completed YC Winter ‘18 Batch and hit $40k monthly sales in February on 2.7k total customers, and in the process of raising a target $2M seed round. Learn more at gogainful.com",
        },
        {
          name: "RoBhat Labs",
          description:
            "Using machine learning techniques and cryptography to stop the spread of misinformation. Signed contract with the DNC and frequently feature on MSNBC, Wired, and other outlets. Currently focused on making their product production-ready and doing demos to secure paying clients for the November 2018 elections. Sample article on their work here",
          links: [
            {
              address: "https://www.robhat.com/",
              title: "Website",
            },
          ],
          logo: robhat,
        },
        {
          name: "Madtech Labs",
          links: [
            {
              address: "https://angel.co/company/madtech-labs/jobs",
              title: "Angel.co",
            },
          ],
          description:
            "Developing tertiary hybrid power trains as B2B products to disrupt the transportation market. Two-person founding team with deep industry expertise comprised of a PhD in mechanical engineering and an undergraduate specializing in customer development. To date have validated the technology in the lab, and are seeking to scale with customers during this semester and raise a small seed round",
        },
        {
          name: "Coverstar",
          logo: coverstar,
          links: [
            {
              address: "https://coverstar.app/",
              title: "App website",
            },
            {
              address: "https://angel.co/company/coverstar",
              title: "Angel.co",
            },
          ],
          description:
            "A social app where users create fun Kpop music videos. >100k users (70k MAU) to date with strong engagement metrics, and currently raising a seed round",
        },
        {
          name: "Yearbook",
          description:
            "Realtime YearBook for preschools. Very talented team of undergraduates with domain knowledge and decent traction among schools despite forming recently. Focused on product and customer development over the course of the Free Ventures batch",
        },
      ],
    },
    {
      batchName: "F2017",
      batchNumber: 12,
      companies: [
        {
          name: "onederful",
          description:
            "Onederful provides real-time eligibility and benefits checks connected to over 240+ insurance payers for dental offices. The most common way for front offices to determine reimbursement rates and patient coverage is to phone the insurance company. About 7% of revenue loss is due to denied claims caused by eligibility errors. We have also created an eligibility API allowing other dental software companies to easily integrate eligibility verification into their services, and are currently in contract discussions with several large players. Currently participating in Y Combinator’s Winter ‘18 Batch.",
          links: [
            {
              address: "https://www.onederful.co",
              title: "Website",
            },
            {
              address: "https://www.crunchbase.com/organization/onederful",
              title: "Crunchbase",
            },
            {
              address: "https://www.prnewswire.com/news-releases/vyne-dental-acquires-dental-plan-eligibility-software-maker-onederful-301443979.html",
              title: "Acquisition",
            }
          ],
          tags: [acquisitionTag, ycW2018Tag],
          logo: onederful,
        },
        {
          name: "DataAgora",

          description:
            "DataAgora is a marketplace where consumers can sell their data to data-driven companies. Machine learning is the future and every startup, student and software developer in Silicon Valley wants to create the next big data-driven project. But all of these projects get stuck in a negative feedback loop; in order to get data, they need users, in order to get users, they need a product, but in order to make a product they need data. DataShark breaks that loop and gives data-driven companies direct access to data from consumers. Currently closing pre-seed, institutional investment.",
          links: [
            {
              address: "https://dataagora.com/",
              title: "Website",
            },
          ],
          logo: dataagora,
        },
        {
          name: "FIAT LUX LABS",
          description:
            "Timely and accurate diagnosis of cancers is crucial for prevention and mitigation of cancer progress. D-Luciferin is a non-toxic, light emitting chemical that generates a sensitive and selective luminescence signal in the presence of key biomarkers of ovarian, cervical, and liver cancer. The current method of D-Luciferin production uses costly reagents in an energy intensive process that results in extremely low yields of under 3%. Fiat Lux Labs is generating a novel biochemical process using sugar, grains, and yeast to cut the high cost of D-Luciferin by nearly 70% ($175 to $52). Closed pre-seed angel investment.",
        },
        {
          name: "BUNGALO",
          description:
            "Bungalo is a web platform with the aim of providing students with a simple and secure way to search for housing and subletters, as well as establish trust in Berkeley’s college housing market. Our MVP addresses many pain points that characterize the current search-for-housing experience. First, users will be able to quickly search and filter listings based on user criteria including amenities, gender preference, and property type. Second, people can search for housing with friends and add listings to a shared “wishlist.” Third, users will get notified when new listings that fit their criteria are posted.",
        },
        {
          name: "GENESISX",
          description:
            "The prosthetics industry is full of top-of-the-line prosthetics that cost a small fortune to low-income amputees. Our team is setting out to build general-purpose low-cost myoelectric prosthetics that these amputees can afford. We have won our first contract for a non-profit called ROMP (Range of Motion Project) and are currently working to deliver a low-cost prosthetic elbow to an amputee in Ecuador.",
        },
        {
          name: "REHAPAL",
          description:
            "RehaPal provides a humanoid robot that performs automated passive and active medical rehabilitation, and make physical therapists more productive. Hospitals pay a subscription fee for the robot in order to provide automated medical rehabilitation services for post-stroke patients as well as others who require physical/occupational therapy. Founded by a team of serial entrepreneurs and PhD researchers studying under Ruzena Bajcsy in the Berkeley Artificial Intelligence Research (BAIR) Lab.",
        },
        {
          name: "VENTUREFOLDER",
          description:
            "VentureFolder is a lightweight software service to see what companies angel investors and early stage funds are actively looking at, share potential investments with each investors, and take notes throughout due diligence process. VentureFolder helps investors keep on top of what is happening in their business: track startups, other VC firms, acquisitions, investment themes, and people.",
        },
      ],
    },
    {
      batchName: "S2017",
      batchNumber: 13,
      companies: [
        {
          name: "Paladin Drones",
          description:
            "Paladin Drones is creating autonomous drone solutions for public safety, at a price even volunteer departments can afford. Their product decreases response time by at least two minutes by providing crucial situational awareness to first responders before they arrive on scene. Their solutions have landed them a spot as a finalist for Berkeley Big Ideas, and helped them win the Penn Innovation Grant.",
          link: "https://paladindrones.io",
          logo: paladin,
          tags: [ycS2018Tag],
          links: [
            {
              address:
                "https://techcrunch.com/2019/05/28/paladin-drones-picks-up-1-3m-to-give-first-responders-a-live-feed-of-emergencies/",
              title: "Crunchbase",
            },
          ],
        },
        {
          name: "Layer Six",
          description:
            "Information overload drains the cognitive bandwidth of high-performing individuals and organizations, reducing their peak performance potential. We are the only research-backed cognitive enhancement solution serving this market, bringing data-driven diagnostics, enterprise software, and customized VR therapeutics to the world.",
          logo: layersix,
        },
        {
          name: "Foresight Mental Health",
          description:
            "Transforming mental healthcare by leveraging cutting-edge science and technology while remaining affordable and accessible. Care at Foresight begins with building a patient profile based on the patient's genetic profile, comprehensive symptom profile, brain-chemical balance estimates, mental health history, family history, lifestyle, and many other factors. With the patient profile, the Foresight Platform analyzes hundreds of thousands of pages of clinical research to assist our doctors in accurately and quickly identifying the optimal treatment for the patient. Weekly surveys via our patient portal keep the patient's symptom profile constantly up to date. Practice-issued wearable devices continuously monitor sleep, exercise, stress, anxiety, mood, and other key factors of mental health. Based on the patient's status, treatment plans are updated. At Foresight, we are committed to leveraging technology to improve mental healthcare.",
          logo: foresight,
        },
        {
          name: "Memory",
          description:
            "An Alexa-based voice assistant for individuals with Alzheimer’s. It responds to patients’ questions using information provided by family members and caretakers, and collects data used for medical research and improvement. Memory’s goal is to reduce the burden on caretakers and allow physicians and healthcare providers to provide customized treatment methods directly to patients in their own homes.",
          logo: memory,
        },
        {
          name: "Peereditr",
          description:
            "The quickest way to get feedback. It's a feedback and collaboration tool designed for visual documents like resumes, slide decks, and marketing material. It takes one click to create a feedback room with annotation tools and version control, which you can share with anyone. Our goal is to provide the quickest and most seamless feedback experience.",
          logo: peereditr,
        },
        {
          name: "Acuity For Moms",
          description:
            "An online platform that empowers moms to re-enter the workforce by providing online skills training and community. Our platform aggregates existing online courses — think Coursera and EdX — to create customized learning paths based on skills, interests, personality, and time availability. These courses are coupled with a community of like-minded moms and value-add resources in order to help moms ultimately return to the workforce.",
          logo: acuity,
        },
      ],
    },
    {
      batchName: "F2016",
      batchNumber: 13,
      companies: [
        {
          name: "Pantheon VR",
          description:
            "Pantheon is a VR application that makes 3D modeling and animation immersive and effortless. We seek to create a tool that drives people to create beautiful 3D content, the same way Instagram made photographers, Medium made writers, and Youtube made filmmakers. We’ve created a simple set of tools that you use while immersed in VR, that let you to easily build, animate, and share your digital world. We took a process that takes weeks to learn and brought it down to minutes. Pantheon allows anyone to quickly and easily create 3D content, and share it with others. ",
          logo: pantheon,
          tags: [acquisitionTag, ycS2017Tag],
          links: [
            {
              address: "https://www.crunchbase.com/organization/pantheon-3",
              title: "Crunchbase",
            },
          ],
        },
        {
          name: "Iota Labs",
          description:
            "Introducing Dot, the physical push notification that tells your phone where you are so that it understands your behaviors and patterns in the places that make up your life (bedroom, living room, garage, backyard, work, car, etc). Dot serves a dual purpose: it provides ultra-precise location data to your smartphone, and allows users to create extensible, interactive interfaces anywhere. This combination creates an invaluable asset when dealing with data — context.",
          tags: [kickstarterTag],
          links: [
            {
              address:
                "https://www.kickstarter.com/projects/1867163750/dot-the-physical-push-notification",
              title: "Kickstarter",
            },
            {
              address: "https://www.crunchbase.com/organization/iota-labs",
              title: "Crunchbase",
            },
          ],
          logo: iota,
        },
        {
          name: "CHANNELTIME.TV",
          description:
            "ChannelTime.tv’s goal is to create a service that improves upon other video-sharing sites for all types of users: viewers, content creators, and even advertisers. Using microtransactions, viewers can directly support the content creators they love. Content creators gets a constant amount per view, and more with “just ask” payments. Viewers can support the content creators they love directly. Advertisers benefit because watching ads on ChannelTime.tv is entirely optional and advertisers directly reward the viewers so there is a positive emotional response to their promotions",
          links: [
            {
              address:
                "https://laughingsquid.com/channeltime-tv-a-social-streaming-service-that-compiles-videos-from-reddit-into-a-single-feed/",
              title: "Article",
            },
          ],
          logo: channeltime,
        },
        {
          name: "HOMESLICE",
          description:
            "HomeSlice is a platform focused on making home ownership more accessible by facilitating fractional purchases between like-minded individuals. Real estate prices have reached a level where much of the population is priced out of the market and forced to rent. ",
          logo: homeslice,
        },
        {
          name: "Petra",
          description:
            "Petra is a service that empowers millennials who have not received quality financial advice to take control of their financial future.Our app provides users with budgeting tools, personal financial education, and a personalized plan. The plan helps users understand their financial health, watch and control their spending, pay off debts, and put money into investments (for young people, this is the most important and impactful time to be investing).",
          logo: petra,
        },
        {
          name: "IRIS BCI",
          description:
            "At Iris BCI we are building a AAC device that allows an individual to talk using just their brain waves. The user will be using consciously controllable thought processes that can be picked up as EEG signals (brainwaves) and a simple senary language (base 6) that is used to output speech in normal everyday languages by the device.",
          logo: iris,
        },
      ],
    },
    {
      batchName: "S2016",
      companies: [
        {
          name: "Distributed Systems",
          description:
            "Pavlov is a simple interface to build and manage enterprise machine intelligence applications. Pavlov's current technology brings enterprise support and tooling to critical data processing technologies, enabling teams to quickly build, deploy, and scale machine learning pipelines out-of-the-box. Pavlov is currently focused on addressing fraud related use cases, making sense of textual and rich media content at scale via Pavlov Spot, their first product offering. ",
          logo: distributed,
          tags: [acquisitionTag],
          links: [
            {
              address: "https://techcrunch.com/2018/08/15/login-with-coinbase/",
              title: "Acquisition",
            },
          ],
        },
        {
          name: "Opthrift",
          description:
            "Helps people purchase like-new high-end products from sites like Craiglist and eBay. We provide domain-specific expertise, and handle negotiation, purchase, and delivery for our customers so they can get a convenient, personal shopping experience at thrift prices.",
          logo: opthrift,
        },
        {
          name: "Photon",
          description:
            "A mobile app that generates industry-grade shading analysis reports for solar installers. By attaching an inexpensive fisheye lens to his or her smartphone, a solar designer can take photos on a roof to find the optimal placement of solar panels. The solar industry’s best solution for this is a device from 2006 that costs $3,000 secondhand. The secret is that all of this device’s hardware components are found on today’s smartphone. We plan to sell to small to medium sized solar integrators. We’re generating a quote instantly, while the current solutions can take weeks on average. The unsustainable energy situation needs to be solved this century, and the solution starts with products like ours.",
          logo: photon,
          links: [
            {
              address: "https://www.tryphoton.com/",
              title: "Website",
            },
            {
              address:
                "https://www.indiehackers.com/interview/building-an-app-for-the-solar-industry-growing-to-1-000-mo-8e9f6d12b4",
              title: "Article",
            },
          ],
        },
        {
          name: "TileWorks",
          description:
            "Every major retail industry requires some form of inventory warehouse, filled with forklifts, aisles and manpower. Imagine being able to eliminate the need for all these and increase efficiency at the same time. TileWorks is an overhead transportation system that revolutionizes commercial storage by using an innovative trackless grid layout adaptable to any commercial ceiling. The system not only allows for robots to rapidly pick up and deliver objects to any location, but it also doubles available storage capacity.",
          logo: tileworks,
        },
        {
          name: "Diced",
          description:
            "A grocery delivery service that makes it easy to cook meals at home. For $42 a week, we send you 6 recipes along with the ingredients to cook each recipe. Each meal is delicious and can be made in 15 minutes. We can deliver an amazing experience at practical prices by offloading the cost of sourcing, preparing, and packaging ingredients to grocery stores.",
          logo: diced,
        },
      ],
    },
    {
      batchName: "F2015",
      batchNumber: 12,
      companies: [
        {
          name: "Lifted",
          description:
            "An iPad app that makes life easier for special education teachers, therapists, and behavior analysts to help accelerate the learning outcomes for the ~7M students (preK-12) with learning disabilities in the US.",
        },
        {
          name: "Thera",
          description:
            "1 in 4 college women and 1 in 33 college men will be sexually assaulted by the time they graduate. And 40% of survivors never tell anyone, not even their closest friends or family members, due to the stigma associated with rape culture and the lack of accessible, safe resources. As a result, these survivors never receive the help they deserve and need. Thera is an online chat platform that connects survivors of sexual assault to certified experts for anonymous and confidential support. With Thera, users receive quality care and advice while protecting their identities. ",
        },
        {
          name: "Wildfire",
          description:
            "A local safety app that crowd sources crime reporting to users. When breaking news happens in your local area, how do you find out about it and how quickly do you hear?",
          logo: wildfire,
          links: [
            {
              address:
                "https://www.huffpost.com/entry/wildfire-app-alerts-users_b_9287408",
              title: "Huffington Post Article",
            },
            {
              address: "https://www.getwildfire.com/",
              title: "App Website",
            },
          ],
          tags: [acquisitionTag, ycS2017Tag],
        },
        {
          name: "Nom Nom",
          description:
            "Their mission is to empower local culinary talent to share their food to their community by providing an online marketplace for home-styled artisan food.",
        },
        {
          name: "Sigma Sports",
          description:
            "A wearable device with a software component to help coaching staff monitor athletes' training and conditioning. ",
        },
        {
          name: "Smart Notes",
          description:
            "An interactive notebook designed to help students, particularly students in STEM, learn more effectively.",
        },
      ],
    },
    {
      batchName: "S2015",
      batchNumber: 12,
      companies: [
        {
          name: "C. Light Technologies",
          description:
            "Right now there are 24 million people suffering from Alzheimer’s disease. This number is projected to increase to 100 million by 2050. And the sad truth is, in terms of diagnostics, the field of neurology is decades behind other areas of medicine. There are no quick, non-invasive diagnostics for Alzheimer’s and many other neurological disorders including Parkinson’s, MS, ALS, and Schizophrenia. All of these diseases, exhibit abnormal eye movements. However, the only eye-movements clinicians are able to observe now are quite large, due to a lack of fine resolution available in current clinical tools. This makes any small changes completely invisible to clinicians. We at C. Light Technologies are working to fill in the diagnostic tool gap through the use of our precision eye tracker.",
          photos: [
            {
              src: c1,
            },
          ],
        },
        {
          name: "Improving Outcomes",
          description:
            "Healthcare providers currently have very little information on what happens to their patients after they leave the hospital unless they get readmitted or have a complication. Any follow-up data that does exist is rarely collected in a systematic or meaningful way. We want to change that by closing the feedback loop, bringing this critical information back to the point-of-care so everyone can align around what ultimately matters - patient outcomes. Our platform enables healthcare providers to seamlessly collect information on the functional, symptomatic and quality-of-life outcomes of care using clinically validated patient-reported surveys. We use this data to help the care-team better manage patients, predict the outcomes of treatments and facilitate reporting of outcomes to payers and the public",
          photos: [
            {
              src: outcomes1,
            },
          ],
        },
        {
          name: "Blitz E-Sports",
          description:
            "Blitz Esports is a tech and media startup focused on bridging the gap between esports fandom and personal gameplay. We're one of the premier media publications in esports, specializing in educational video content for League of Legends, CS:GO and Overwatch. We've also developed the first fully automatic League of Legends coaching app, which uses computer vision and data-driven insights to proactively help gamers make better decisions at each step of their gameplay experience. A month into open beta, the Blitz app is now used in over a million games each week.",
          logo: blitz,
          links: [
            {
              address:
                "https://www.crunchbase.com/organization/instant-esports#section-funding-rounds",
              title: "Crunchbase",
            },
            {
              address:
                "https://medium.com/@blitzesports/the-blitz-team-joins-discord-e3b17578966b",
              title: "Acquisition",
            },
          ],
          tags: [acquisitionTag, ycS2015Tag],
          photos: [
            {
              src: blitz1,
            },
          ],
        },
        {
          name: "Rooster",
          description:
            "There was a time where neighbors loved to help one another - they shared and gifted. This behavior almost completely disappeared with our rapid online lifestyle, and yet we all wish we could have it back. We are Rooster: a local sharing community where we help, borrow and share with each other, as neighbors. On Rooster anyone can ask for whatever they need and help whenever they can, the only rule: it has to be for free.  Thousands of Rooster members have given away sofas, TVs, Art supplies and clothes, borrowed baby cribs and baseball bats, got together to jog, play, consult and much more.  Rooster is available in select Bay Area locations.",
          logo: rooster,
          links: [
            {
              address: "https://therooster.co/",
              title: "Website",
            },
            {
              address: "https://www.crunchbase.com/organization/roosters-inc",
              title: "Crunchbase",
            },
          ],
          photos: [
            {
              src: rooster1,
            },
          ],
        },
        {
          name: "Wist",
          description:
            "Wist is a smart waitlist that lets users remotely join restaurant waitlists while providing machine learning driven wait time predictions. ",
          photos: [
            {
              src: wist1,
            },
          ],
        },
        {
          name: "Zypper",
          description:
            "Businesses worldwide are becoming increasingly reliant on finding the right products and services to grow with. They want to purchase fast, but on average, companies take 12 months to make a single purchasing decision. Why? The current procurement process is slow, bureaucratic, and highly expensive. Zypper aims to eliminate wasted time in the enterprise procurement process, producing cost savings of 25%. Simply put, Zypper makes your enterprise purchases smart, simple, and fast.",
          photos: [
            {
              src: zypper1,
            },
          ],
        },
      ],
    },
    {
      batchName: "F2014",
      companies: [
        {
          name: "Nimble",
          description:
            "Nimble is a cloud-based radiation oncology planning system that uses novel optimization tools, big data, and cross-institution insights to dramatically lower the cost and improve treatment outcomes throughout the healthcare industry.",
          photos: [
            {
              src: nimble1,
            },
          ],
        },
        {
          name: "Obsidian",
          description:
            "Obsidian is a peer-backed payment manager that allows users to pay for anything in flexible installments. Users can use any payment method, including Bitcoin, to make purchases for users, and allow them to determine their repayment duration and installment intervals",
          photos: [
            {
              src: obsidian,
            },
          ],
        },
        {
          name: "Unboard",
          description:
            "Bringing the magic of tabletop games to the digital world. First, Unboard generates traction and popularity by virtualizing board games with established audiences. Then, we utilize it by launching the first ever all-medium Trading Card Game.",
          photos: [
            {
              src: unboard,
            },
          ],
        },
        {
          name: "Crowd Control",
          description:
            "Crowd Control is accurately measuring how crowded public spaces are in real-time and predicting how crowded they will be in the future. This allows customers to decide when to go to their favorite gyms, supermarkets, restaurants, etc and businesses can better manage their establishments.",
          photos: [
            {
              src: crowdcontrol1,
            },
          ],
        },
        {
          name: "Glints",
          description:
            "Glints partners with companies to develop real-world challenges for youths. Rather than academic knowledge, candidates gain real work experience and career skills. They gain employability by self-directing their own career development as they acquire badges for the career skills they seek.",
          links: [
            {
              address: "https://glints.com/",
              title: "Website",
            },
            {
              address: "https://www.crunchbase.com/organization/glints",
              title: "Crunchbase",
            },
            {
              address:
                "https://vulcanpost.com/668927/glints-funding-series-b-singapore/",
              title: "Series B Article",
            },
          ],
          logo: glints,
          photos: [
            {
              src: glints1,
            },
          ],
        },
        {
          name: "Tablink",
          description:
            "Tablink manages browser tabs. We cluster tabs and create a 'tab' filesystem, allowing users to sync and find information instantly. We tackle the problem of having excessive tabs open, which limits productivity and affects over 60% of internet users.",
          photos: [
            {
              src: tablink1,
            },
          ],
        },
      ],
    },
    {
      batchName: "S2014",
      companies: [
        {
          name: "Demilune",
          description:
            "The Demilune walker is an adjustable full-size walker that is able to provide support in both its large configuration and its much smaller form. The adjustable design makes the walker effective in all areas of the home, helping to prevent in-home falls and promote independence among the elderly.",
          photos: [
            {
              src: demilune1,
            },
          ],
        },
        {
          name: "SmartBod",
          description:
            "SmartBod builds vibrators that learn from and adapt to a woman's physiological responses, heightening her level of pleasure and enlightening her (and her sexual partner) about her sexual preferences.",
          photos: [
            {
              src: smartbod1,
            },
          ],
        },
        {
          name: "Etch",
          description:
            "Simplicity and intricacy never seem to coexist on a business card, but Etch opens the door to a lean business card that shows every single aspect of yourself by allowing you to store all your professional and social information on the cloud--accessed by scanning the Etch Code.",
          photos: [
            {
              src: etch1,
            },
          ],
        },
        {
          name: "Bru",
          description:
            "A fully robotic personalized bartender controlled with just a tap on your phone. The machine mixes a nearly endless combination of familiar and exotic drinks by precisely combining up to 16 ingredients. Potential markets range from homes to hotels.",
          photos: [
            {
              src: bru1,
            },
          ],
        },
        {
          name: "Einstein",
          description:
            "Einstein helps users looking to purchase a product make the best informed decision. By intelligently consolidating customer and professional product reviews and understanding all the customers' needs using basic questions, Einstein can recommend the best product.",
          photos: [
            {
              src: einstein1,
            },
          ],
        },
        {
          name: "Iris",
          description:
            "Iris is a community for people's interests where users write articles about their passions and share them with like-minded people. They aim to solve the issue with reach, engagement, and discovery that bloggers have through a keyword extraction algorithm.",
          photos: [
            {
              src: iris1,
            },
          ],
        },
      ],
    },
  ],
  pressList: [
    {
      image: forbes,
      title:
        "Huge congratulations to FreeV co-founder Jeremy Fiance for being featured on the 2017 Forbes 30 Under 30 list!",
      address:
        "https://www.forbes.com/pictures/lmh45edlmk/30-under-30-education/#1abbfbef1c3d",
      date: "Jan 3, 2017",
    },
    {
      image: wired,
      title: "The College Kids Doing What Twitter Won't",
      address:
        "https://www.wired.com/story/the-college-kids-doing-what-twitter-wont/",
    },
    {
      image: e27,
      title:
        "Singaporean startup Glints has raised US$2M Series A to help you find a job",
      address:
        "https://e27.co/singaporean-startup-glints-has-raised-us2million-series-a-to-help-you-find-a-job-20160905/",
      date: "Sep 5, 2016",
    },
    {
      image: tc,
      title: "Meet VC Jeremy Fiance, UC Berkeley's 24-year-old superconnector",
      address:
        "http://techcrunch.com/2016/04/18/meet-vc-jeremy-fiance-uc-berkeleys-24-year-old-superconnector/",
    },
    {
      image: forbes,
      title:
        "Huge congratulations to FreeV co-founder Jeremy Fiance for being featured on the 2017 Forbes 30 Under 30 list!",
      address:
        "https://www.forbes.com/pictures/lmh45edlmk/30-under-30-education/#1abbfbef1c3d",
    },
    {
      image: huffpost,
      title: "Wildfire App Alerts Users of Emergency Situations",
      address:
        "http://www.huffingtonpost.com/rawan-abushaban/wildfire-app-alerts-users_b_9287408.html",
    },
    {
      image: tc,
      title: "YC-Backed Instant eSports Is ESPN for Competitive Gaming",
      address:
        "http://techcrunch.com/2015/06/29/yc-backed-instant-esports-is-espn-for-competitive-gaming/",
    },
    {
      image: recode,
      title:
        "Searching for the Next Stanford: Silicon Valley Turns Its Eyes to Berkeley",
      address:
        "http://recode.net/2015/05/07/searching-for-the-next-stanford-silicon-valley-turns-its-eyes-to-berkeley/",
    },
    {
      image: tc,
      title:
        "Lily, A Camera Drone That Automatically Follows You, Pulls In A Mountainous $34 Million In Pre-Orders",
      address:
        "http://techcrunch.com/2016/01/08/lily-a-camera-drone-that-automatically-follows-you-pulls-in-a-mountainous-34-million-in-pre-orders/",
    },
    {
      image: bb,
      title: "Meet Free Ventures Managing Director Cameron Baradar",
      address: "https://vimeo.com/106034256",
    },
    {
      image: mic,
      title: "The Vibrator of the Future Is Here - And Women Should Be Excited",
      address:
        "http://mic.com/articles/112886/a-pair-of-entrepreneurs-want-to-make-sure-every-woman-gets-the-pleasure-she-deserves#.oWYar7k3v",
    },
    {
      image: recode,
      title:
        "Free Ventures Is Seeking the Next Mark Zuckerberg to Drop In and Maybe Drop Out",
      address:
        "http://recode.net/2014/06/08/free-ventures-is-seeking-the-next-mark-zuckerberg/",
    },
    {
      image: alchemy,
      title: "Free Ventures - Students Turning Cool Ideas into Startups",
      address: "http://blog.alchemyapi.com/free-ventures-students-startups",
    },
    {
      image: bb,
      title: "Free Ventures: First accelerator for and by students",
      address:
        "http://www.berkeleybyte.com/2014/03/07/free-ventures-first-accelerator-for-and-by-students/",
    },
    {
      image: dailycal,
      title:
        "Student-run incubator program hosts competition for startups at SkyDeck Berkeley",
      address:
        "http://www.dailycal.org/2013/12/10/student-run-incubator-program-hosts-competition-startups-skydeck-berkeley/",
    },
    {
      image: dailycal,
      title:
        "UC Berkeley student-run organization aims to help undergrads launch startups",
      address:
        "http://www.dailycal.org/2013/09/16/uc-berkeley-student-run-organization-aims-to-help-undergrads-launch-startups/",
    },
  ],
  // large fundraising doesn't have a tag so we define that group here.
  largeFundraisingNames: ["Gainful", "Glints", "Foresight Mental Health", "Watney Robotics"],
};

export default portfolioContent;
